// src/pages/Users/Produits/utils/productsUtils.js

export const FALLBACK_PRODUCT_IMG = "/img/no-image.jpg";

export const collatorFR = new Intl.Collator("fr", {
  sensitivity: "base",
});

export function safeString(value = "") {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

export function ensureHttp(url = "") {
  const value = safeString(url);

  if (!value) return "";

  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}

export function parseDemoLinks(input) {
  return (Array.isArray(input) ? input : String(input || "").split(";"))
    .map((item) => item.trim())
    .filter(Boolean);
}

export function hostLabel(url, index) {
  try {
    const { hostname } = new URL(ensureHttp(url));

    return hostname.replace(/^www\./, "");
  } catch {
    return `Démo ${index + 1}`;
  }
}

export function sortProductsByOrder(products = []) {
  return [...products].sort((a, b) => {
    return (
      Number(a?.ordre_app ?? 9999) -
        Number(b?.ordre_app ?? 9999) ||
      collatorFR.compare(
        safeString(a?.nom_app),
        safeString(b?.nom_app)
      )
    );
  });
}

export function countDemoLinks(products = []) {
  return products.reduce((total, product) => {
    return total + parseDemoLinks(product?.lien_url_app).length;
  }, 0);
}

export function getProductImage(product) {
  const image = safeString(product?.image_url_app);

  return image || FALLBACK_PRODUCT_IMG;
}